import React from 'react'
import { MARKETPLACE_LABELS, MARKETPLACE_COLORS } from '@/utils/hooks/useSalesVolume'
import OrdNetIcon from '@/icons/ord-net'
import SatflowIcon from '@/icons/satflow'
import OkxIcon from '@/icons/okx'

export const saleMarketplace = (item: any): number | null => {
	const mp = item?.marketplace ?? item?.escrow?.marketplace
	if (typeof mp !== 'number' || !Number.isFinite(mp)) return null
	return mp !== 0 && MARKETPLACE_LABELS[String(mp)] ? mp : null
}

const marketplaceGlyph = (mp: number): string => {
	switch (mp) {
		case 1:
			return 'W' // OrdinalsWallet (rendered as logo, not glyph)
		case 2:
			return 'S' // Satflow
		case 3:
			return 'M' // MagicEden
		case 4:
			return 'X' // OrdSwap
		case 5:
			return 'G' // Gamma
		case 6:
			return 'B' // OrdinalsMarketBTC
		case 8:
			return 'O' // OKX (rendered as its grid mark, not the glyph)
		case 9:
			return 'U'
		case 10:
			return 'N'
		case 11:
			return 'D' // Ord Dropz (rendered as its logo, not the glyph)
		case 12:
			return 'D' // DotSwap (rendered as its logo, not the glyph)
		case 100:
			return 'S' // SUBFROST (rendered as its snowflake, not the glyph)
		default:
			return '·'
	}
}

export const MarketplaceIcon: React.FC<{ marketplace: number }> = ({ marketplace }) => {
	const key = String(marketplace)
	if (!MARKETPLACE_LABELS[key] || key === '0') return null

	const label = MARKETPLACE_LABELS[key] ?? 'Other'
	const color = MARKETPLACE_COLORS[key] ?? '#6b7280'
	const isOw = marketplace === 1
	const isSatflow = marketplace === 2
	const isOrdNet = marketplace === 10
	const isUnisat = marketplace === 9
	const isOkx = marketplace === 8
	const isSubfrost = marketplace === 100
	const isOrdDropz = marketplace === 11
	const isDotSwap = marketplace === 12
	return (
		<span
			title={label}
			aria-label={label}
			className="inline-flex shrink-0 items-center justify-center size-[14px] rounded-[3px] text-[9px] font-bold text-white overflow-hidden"
			style={{
				backgroundColor:
					isOw ||
					isSatflow ||
					isOrdNet ||
					isUnisat ||
					isOkx ||
					isSubfrost ||
					isOrdDropz ||
					isDotSwap
						? 'transparent'
						: color
			}}
		>
			{isOw ? (
				<img src="/logo-icon.svg" alt="OW" className="w-full h-full" />
			) : isSubfrost ? (
				<img src="/subfrost.svg" alt="SUBFROST" className="w-full h-full" />
			) : isOrdDropz ? (
				<img src="/ord-dropz.png" alt="Ord Dropz" className="w-full h-full rounded-[3px]" />
			) : isDotSwap ? (
				<img src="/dotswap.png" alt="DotSwap" className="w-full h-full rounded-[3px]" />
			) : isUnisat ? (
				<img src="/unisat.svg" alt="UniSat" className="w-full h-full" />
			) : isSatflow ? (
				<SatflowIcon className="size-[10px] text-foreground" />
			) : isOkx ? (
				<OkxIcon className="size-[10px] text-foreground" />
			) : isOrdNet ? (
				<OrdNetIcon className="size-[12px]" />
			) : (
				marketplaceGlyph(marketplace)
			)}
		</span>
	)
}

export function SaleMarketplaceIcon({ sale }: { sale: any }) {
	const marketplace = saleMarketplace(sale)
	return marketplace === null ? null : <MarketplaceIcon marketplace={marketplace} />
}
